import { motion } from "framer-motion";
import { rgba } from "polished";
import styled, { css } from "styled-components";

import { vars } from "../../styles";

export const Modal = styled(motion.div)<{
  $active?: boolean;
  $size?: "wide" | "narrower" | "narrow" | "full" | "fuller";
}>`
  cursor: default;

  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-inner {
    width: 56rem;
  }

  /* narrow */
  ${(props) =>
    props.$size == "narrower" &&
    css`
      .modal-inner {
        width: 36rem;
      }
    `}

  /* narrow */
  ${(props) =>
    props.$size == "narrow" &&
    css`
      .modal-inner {
        width: 46rem;
      }
    `}

  /* full */
  ${(props) =>
    props.$size === "full" &&
    css`
      .modal-inner {
        width: 66rem;
      }
    `}

  /* fuller */
  ${(props) =>
    props.$size === "fuller" &&
    css`
      .modal-inner {
        width: 76rem;
      }
    `}
  
  /* wide */ 
  ${(props) =>
    props.$size == "wide" &&
    css`
      .modal-inner {
        width: 96rem;
      }
    `} 

    /* active */
  ${(props) =>
    props.$active &&
    css`
      .modal-inner {
        pointer-events: auto;
        z-index: ${vars.zIndex.modalContent};
      }
    `}
`;

export const ModalOverlay = styled(motion.div)<{ $active?: boolean }>`
  background-color: ${rgba("#000", 0.7)};
  position: fixed;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;

  /* active */
  ${(props) =>
    props.$active &&
    css`
      opacity: 1;
      pointer-events: auto;
      cursor: default;
      z-index: ${vars.zIndex.modalOverlay};
    `}
`;

export const ModalInner = styled.div`
  pointer-events: none;
  display: flex;
  max-height: 80%;
`;

export const ModalCard = styled.div`
  padding: 2.4rem 3.2rem;
  position: relative;
  border-radius: 1.5rem;
  background-color: ${vars.colors.grey100};
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const ModalCardScrollWrap = styled.div`
  overflow: hidden;
  display: flex;
`;

export const ModalCardScroll = styled.div<{ disableScroll?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 1rem;

  ${(props) =>
    props.disableScroll &&
    css`
      overflow-y: hidden;
      padding-right: 0;
    `}
`;

export const ModalVariant = {
  initial: { opacity: 0 },
  isOpen: { opacity: 1 },
  exit: { opacity: 0 },
};

export const ContainerVariant = {
  initial: {
    transform: "scale(0.85)",
    top: "50%",
    transition: { type: "opacity .25s cubic-bezier(0,1,.4,1),transform .25s cubic-bezier(.18,1.25,.4,1)" },
  },
  isOpen: { top: "50%", transform: "scale(1)" },
  exit: {
    top: "50%",
    transform: "scale(0)",
    transition: { type: "opacity .25s cubic-bezier(0,1,.4,1),transform .25s cubic-bezier(.18,1.25,.4,1)" },
  },
};
